import { createTripletGlyphIcon } from '../../../utils/createTripletGlyphIcon';

/** Source: `svg-to-react-generator/source-svgs/outline/{S,M,L}/info.svg` */
export const InfoIcon = createTripletGlyphIcon('InfoIcon', {
  s: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8 5.97656C8.30376 5.97656 8.5498 6.22261 8.5498 6.52637V11.4365C8.54972 11.7402 8.30371 11.9863 8 11.9863C7.6963 11.9863 7.45028 11.7402 7.4502 11.4365V6.52637C7.4502 6.22261 7.69625 5.97657 8 5.97656Z"
        fill="currentColor"
      />
      <path
        d="M7.99316 4.2002C8.3612 4.2002 8.6599 4.49824 8.66016 4.86621C8.66016 5.2344 8.36135 5.5332 7.99316 5.5332C7.62513 5.53302 7.32715 5.23429 7.32715 4.86621C7.3274 4.49835 7.62529 4.20038 7.99316 4.2002Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 1.28223C11.7097 1.28246 14.7166 4.29034 14.7168 8C14.7166 11.7097 11.7097 14.7166 8 14.7168C4.29034 14.7166 1.28246 11.7097 1.28223 8C1.28246 4.29034 4.29034 1.28246 8 1.28223ZM8 2.38184C4.89786 2.38207 2.38207 4.89786 2.38184 8C2.38207 11.1021 4.89786 13.617 8 13.6172C11.1021 13.617 13.617 11.1021 13.6172 8C13.617 4.89786 11.1021 2.38207 8 2.38184Z"
        fill="currentColor"
      />
    </svg>
  ),
  m: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 6.72266C9.30361 6.72266 9.54957 6.96891 9.5498 7.27246V12.9346C9.54976 13.2383 9.30373 13.4844 9 13.4844C8.69628 13.4844 8.45024 13.2383 8.4502 12.9346V7.27246C8.45043 6.96891 8.6964 6.72266 9 6.72266Z"
        fill="currentColor"
      />
      <path
        d="M8.99707 4.72461C9.4112 4.72461 9.74694 5.06051 9.74707 5.47461C9.74707 5.88882 9.41128 6.22461 8.99707 6.22461C8.58286 6.22461 8.24707 5.88882 8.24707 5.47461C8.2472 5.06051 8.58294 4.72461 8.99707 4.72461Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 1.51172C13.1358 1.51172 16.4883 4.86423 16.4883 9C16.4881 13.1357 13.1357 16.4883 9 16.4883C4.86431 16.4883 1.51185 13.1357 1.51172 9C1.51172 4.86423 4.86423 1.51172 9 1.51172ZM9 2.61133C5.47174 2.61133 2.61133 5.47174 2.61133 9C2.61146 12.5281 5.47182 15.3887 9 15.3887C12.5282 15.3887 15.3885 12.5282 15.3887 9C15.3887 5.47174 12.5283 2.61133 9 2.61133Z"
        fill="currentColor"
      />
    </svg>
  ),
  l: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.0254 8.96387C12.4395 8.96387 12.7753 9.29974 12.7754 9.71387V17.2295C12.7754 17.6437 12.4396 17.9795 12.0254 17.9795C11.6112 17.9795 11.2754 17.6437 11.2754 17.2295V9.71387C11.2755 9.29974 11.6112 8.96387 12.0254 8.96387Z"
        fill="currentColor"
      />
      <path
        d="M11.9902 6.2998C12.5424 6.2998 12.9901 6.74766 12.9902 7.2998C12.9902 7.85209 12.5425 8.2998 11.9902 8.2998C11.438 8.2998 10.9902 7.85209 10.9902 7.2998C10.9904 6.74766 11.4381 6.2998 11.9902 6.2998Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2.00098C17.5221 2.00117 21.9988 6.47789 21.999 12C21.9988 17.5221 17.5221 21.9988 12 21.999C6.47789 21.9988 2.00117 17.5221 2.00098 12C2.00116 6.47788 6.47788 2.00116 12 2.00098ZM12 3.49707C7.30393 3.49725 3.49725 7.30393 3.49707 12C3.49727 16.6961 7.30394 20.5037 12 20.5039C16.696 20.5037 20.5037 16.696 20.5039 12C20.5037 7.30394 16.6961 3.49727 12 3.49707Z"
        fill="currentColor"
      />
    </svg>
  ),
});
